import { useCallback } from "react";
import {
  MelcoModelsUser,
  UserManagementApi,
  useAPIAction,
} from "melco-shared-logic";
//import { useTranslation } from "react-i18next";

export const useAddUserProfile = () => {
  //const { t } = useTranslation();
  const [AddUserProfile] = useAPIAction(
    UserManagementApi,
    async (api, userAddObj: MelcoModelsUser) => {
      //debugger; console.log(userEditObj)
      const data = await api.userRegister({
        melcoModelsUser: userAddObj,
      });

      return {
        successMessages: [{ message: "default" }],
        data,
      };
    },
    { skipErrorHandling: true, translationPrefix: "users.actions.add" }
  );

  return useCallback(
    async (userEditObj: MelcoModelsUser) => {
      return await AddUserProfile(userEditObj);
    },
    [AddUserProfile]
  );
};
